const initialState = {viewType: "", datesWithLocations: [], isSdAdmin: false, socketUrl: ''}

const updatedDatesWithLocations = (state, payload) => {
  const events = state.altReservationView.datesWithLocations
  const event = events.find(e => e.id == payload.message.game_id)

  if (event && payload.message.confirmed && state.viewType != 'Alt')
    event.className += ' event_confirmed'

  event.total = `${payload.message.players_count}/${payload.message.max_players}`

  return events
}

const altReservationView = (state = initialState, {type, payload}) => {
  switch (type) {
    case 'ALT_RESERVATIONS_VIEW.CHANGE':
      return {...state, ...payload}
    case 'ALT_RESERVATIONS_VIEW.RECEIVED':
      return {...state, datesWithLocations: payload.data, isSdAdmin: payload.isSdAdmin, socketUrl: payload.socketUrl}
    default:
      return state
  }
}

export default altReservationView
